export default function (path) {
    let level = (path.match(/\//g) || []).length;
    if (path.slice(-1) === '/') {
        level -= 1;
    }
    return level;
}
